export default "__VITE_ASSET__BYy_VPIp__"